export var PUSH_MESSAGESTATE = "PUSH_MESSAGESTATE";
export var pushMessageState = function pushMessageState(messageState, authUserId) {
  return {
    messageState: messageState,
    authUserId: authUserId,
    type: PUSH_MESSAGESTATE
  };
};